<!-- contractor-report.vue -->
<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12">
                <qesg-dash-table-card class="h-100" icon="table" title="">
                    <template v-slot:title>
                        <h5 class="d-inline-block font-weight-normal mb-0 mr-2">
                            <span class="text-secondary">{{ $t('기업별 평가결과 현황') }}</span>
                            <b-badge variant="info" class="text-white ml-2" pill>
                                <small>{{ result_history.length }} {{ $i18n.locale == 'ko' ? '개 기업': 'Companies' }}</small>
                            </b-badge>
                        </h5>
                    </template>

                    <b-row no-gutters class="border-top border-bottom border-color-gray-300 py-3 px-3">
                        <b-col cols="6" md="6" xl="4">
                            <b-input-group>
                                <b-form-input v-model="reportSearchForm.company_name"
                                    :title="$t('참여기업 이름 검색')"
                                    :placeholder="$t('참여기업 이름을 입력해주세요')"
                                    :disabled="client_report_global_disabled"
                                    trim
                                    />
                                    <!-- @keyup.enter="searchParticipantByName" -->
                                <b-input-group-append>
                                    <b-btn
                                        variant="light"
                                        class="border"
                                        :disabled="client_report_global_disabled"
                                        :title="$t('조건 검색')"
                                        @click="reportSearchForm.collapseForm = !reportSearchForm.collapseForm"
                                        >
                                        <!-- class="border" -->
                                        <B-Icon-filter variant="" />
                                    </b-btn>
                                    <b-btn
                                        variant="light"
                                        class="border"
                                        :disabled="client_report_global_disabled"
                                        :title="$t('검색 초기화')"
                                        @click="reportSearchForm = { company_name: null, service_type: null, status_code: null, report_type: null, collapseForm: false }"
                                        >
                                        <b-icon-arrow-repeat />
                                    </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col cols="6" md="6" xl="8">
                            <div class="d-flex justify-content-end align-items-center">
                                <!-- <b-btn-group class="mr-2">
                                    <b-btn
                                        variant="light"
                                        class="border ml-auto"
                                        :disabled="client_report_global_disabled"
                                        :title="$t('참여기업 엑셀 다운로드')"
                                        >
                                        <b-icon-download />
                                    </b-btn>
                                    <b-btn
                                        variant="danger"
                                        @click="reportSearchForm = { company_name: null, service_type: null, status_code: null, report_type: null, collapseForm: false }"
                                        :disabled="client_report_global_disabled"
                                        :title="$t('검색 초기화')"
                                        >
                                        <b-icon-arrow-repeat />
                                    </b-btn>
                                </b-btn-group> -->
                                <b-form-select
                                    v-model="result_PerPage"
                                    :options="reportTablePerPageOpt"
                                    :disabled="client_report_global_disabled"
                                    class="w-auto"
                                    />
                            </div>
                        </b-col>
                    </b-row>
                    <b-collapse id="collapse-report-table-filter-form" v-model="reportSearchForm.collapseForm">
                        <b-row>
                            <b-col cols="12">
                                <div class="border bg-light rounded p-3 m-3">
                                    <b-row>
                                        <b-col cols="6" lg>
                                            <b-form-group
                                                id="fieldset-input-report-companyName"
                                                :label="$t('기업명')"
                                                label-for="input-report-companyName"
                                                >
                                                <b-form-input id="input-report-companyName"
                                                    v-model="reportSearchForm.company_name"
                                                    :disabled="client_report_global_disabled"
                                                    trim
                                                    />
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="6" lg="2">
                                            <b-form-group
                                                id="fieldset-input-report-statusType"
                                                :label="$t('평가유형')"
                                                label-for="input-report-statusType"
                                                >
                                                <b-form-select id="input-report-statusType"
                                                    v-model="reportSearchForm.service_type"
                                                    :text-field="`text_${$i18n.locale}`"
                                                    :options="[
                                                        { text_ko: '-- 전체보기 --', text_en: '-- View All --', text_ca: '-- 查看全部 --', value: null },
                                                        { text_ko: '서면평가', text_en: 'On-Desk Assessment', text_ca: '书面评估', value: '일반' },
                                                        { text_ko: '실사평가', text_en: 'On-Site Assessment', text_ca: '实地评估', value: '심화' },
                                                    ]"
                                                    :disabled="client_report_global_disabled"
                                                    >
                                                </b-form-select>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="6" lg="2">
                                            <b-form-group
                                                id="fieldset-input-report-statusCode"
                                                :label="$t('평가상태')"
                                                label-for="input-report-statusCode"
                                                >
                                                <b-form-select id="input-report-statusCode"
                                                    v-model="reportSearchForm.status_code"
                                                    :text-field="`text_${$i18n.locale}`"
                                                    :options="status_code_opts"
                                                    :disabled="client_report_global_disabled"
                                                    >
                                                </b-form-select>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="6" lg="2">
                                            <b-form-group
                                                id="fieldset-input-report-statusCode"
                                                :label="$t('결과보고서 유형')"
                                                label-for="input-report-statusCode"
                                                >
                                                <b-form-select id="input-report-statusCode"
                                                    v-model="reportSearchForm.report_type"
                                                    :text-field="`text_${$i18n.locale}`"
                                                    :options="[
                                                        { text_ko: '-- 전체보기 --', text_en: '-- View All --', text_ca: '-- 查看全部 --', value: null },
                                                        { text_ko: '서면평가 결과보고서', text_en: 'On-desk Assessment Report', text_ca: '书面评估', value: 'report_doc' },
                                                        { text_ko: '실사평가 결과보고서', text_en: 'On-site Assessment Report', text_ca: '实地评估', value: 'report_osis' },
                                                    ]"
                                                    :disabled="client_report_global_disabled"
                                                    >
                                                </b-form-select>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-row>        
                    </b-collapse>
                    <b-row v-if="ecovadis_load_error" no-gutters class="mb-2">
                        <b-col cols="12">
                            <b-alert show variant="warning" class="mb-0">
                                {{ $t('에코바디스 기업 정보를 불러오지 못했습니다. 목록에 에코바디스 기업이 포함되어 있을 수 있습니다.') }}
                            </b-alert>
                        </b-col>
                    </b-row>
                    <b-row no-gutters class="mb-1">
                        <b-col cols="12">
                            <b-table id="result-table"
                                :items="result_history"
                                :per-page="result_PerPage"
                                :current-page="result_CurrentPage"
                                :fields="result_history_fields"
                                :filter="reportSearchForm"
                                :filter-function="filterReportTable"
                                class="border-bottom"
                                :busy="is_loading_result_history"
                                @filtered="onFilterReportTable"
                                >

                                <template #table-busy>
                                    <div class="text-center my-3">
                                        <b-spinner class="align-middle mr-3"></b-spinner>
                                        <strong> Loading...</strong>
                                    </div>
                                </template>

                                <template #cell(index)="data">
                                    {{ ++data.index }}
                                </template>

                                <template #cell(company_name)="data">
                                    {{ data.value }}
                                </template>

                                <template #cell(service_type)="data">
                                    {{ $t(data.value === "일반" ? "서면평가" : "실사평가") }}
                                </template>

                                <template #cell(status_code)="data">
                                    <div class="d-inline px-2 py-1 text-white rounded-pill small"
                                        :style="[{backgroundColor: stats.colors[statsLabel_eng[data.item.manual_status || data.value]]}]"
                                        >
                                        {{ status_code_lang[data.item.manual_status || data.value] }}
                                    </div>
                                </template>

                                <template #cell(report_doc)="data">
                                    <template v-if="data.item.manual_status">
                                        <span class="f-85 gray-500">{{ $t('에코바디스 평가대체') }}</span>
                                    </template>
                                    <template v-else-if="data.item.status_code === 'requested'">
                                        <span class="f-85 gray-500">{{ $t('미시작') }}</span>
                                    </template>
                                    <template v-else-if="data.item.status_code === 'canceled'">
                                        <span class="f-85 gray-500">{{ $t('평가 취소') }}</span>
                                    </template>
                                    <template v-else-if="!data.item.report_doc">
                                        <span class="f-85 gray-500">{{ $t('답변 및 평가 진행중') }}</span>
                                    </template>
                                    <template v-else>
                                        <b-btn-group>
                                            <b-btn size="sm" variant="info" :disabled="client_report_global_disabled"
                                                @click="viewReport(data.item, 'doc')"
                                                >
                                                <div class="d-flex align-items-center">
                                                    {{ $i18n.locale === 'ko' ? '보기' : $i18n.locale === 'ca' ? '查看报告' : 'View' }}
                                                    <template v-if="is_viewing_report && view_target_report?.company_id === data.item.company_id && view_target_report?.report_type === 'doc'">
                                                        <b-spinner class="ml-2" style="width: 0.9rem;height: 0.9rem;" />
                                                    </template>
                                                    <template v-else>
                                                        <BIconEye class="ml-2" font-scale="0.9" />
                                                    </template>
                                                </div>
                                            </b-btn>
                                            <!-- <b-btn size="sm" variant="primary"
                                                @click="downloadReport(data.item, data.item.company_id, 'doc')"
                                                :disabled="client_report_global_disabled"
                                                >
                                                <div class="d-flex align-items-center">
                                                    {{ $t('다운로드') }}
                                                    <template v-if="download_target_report.company_id == data.item.company_id && download_target_report.type == 'doc'">
                                                        <b-spinner class="ml-2" style="width: 0.9rem;height: 0.9rem;" />
                                                    </template>
                                                    <template v-else>
                                                        <BIconDownload class="ml-2" font-scale="0.9" />
                                                    </template>
                                                </div>
                                            </b-btn> -->
                                        </b-btn-group>
                                    </template>
                                </template>

                                <template #cell(report_osis)="data">
                                    <template v-if="data.item.manual_status">
                                        <span class="f-85 gray-500"> {{ $t('에코바디스 평가대체') }} </span>
                                    </template>
                                    <template v-else-if="data.item.status_code === 'requested'">
                                        <span class="f-85 gray-500">{{ $t('미시작') }}</span>
                                    </template>
                                    <template v-else-if="data.item.status_code === 'canceled'">
                                        <span class="f-85 gray-500">{{ $t('평가 취소') }}</span>
                                    </template>
                                    <template v-else-if="data.item.service_type === '일반'">
                                        <span class="f-85 gray-500">
                                            {{ $t('실사평가 비대상') }}
                                        </span>
                                    </template>
                                    <template v-else-if="data.item.report_osis === null">
                                        <span class="f-85 gray-500">{{ $t('답변 및 평가 진행중') }}</span>
                                    </template>
                                    <template v-else>
                                        <b-btn-group>
                                            <b-btn size="sm" variant="info" :disabled="client_report_global_disabled"
                                                @click="viewReport(data.item, 'osis')"
                                                >
                                                <div class="d-flex align-items-center">
                                                    {{ $i18n.locale === 'ko' ? '보기' : $i18n.locale === 'ca' ? '查看报告' : 'View' }}
                                                    <template v-if="is_viewing_report && view_target_report?.company_id === data.item.company_id && view_target_report?.report_type === 'osis'">
                                                        <b-spinner class="ml-2" style="width: 0.9rem;height: 0.9rem;" />
                                                    </template>
                                                    <template v-else>
                                                        <BIconEye class="ml-2" font-scale="0.9" />
                                                    </template>
                                                </div>
                                            </b-btn>
                                            <!-- <b-btn size="sm" variant="primary"
                                                @click="downloadReport(data.item, data.item.company_id, 'osis')"
                                                :disabled="client_report_global_disabled"
                                                >
                                                <div class="d-flex align-items-center">
                                                    {{ $t('다운로드') }}
                                                    <template v-if="download_target_report.company_id === data.item.company_id && download_target_report.type === 'osis'">
                                                        <b-spinner class="ml-2" style="width: 0.9rem;height: 0.9rem;" />
                                                    </template>
                                                    <template v-else>
                                                        <BIconDownload class="ml-2" font-scale="0.9" />
                                                    </template>
                                                </div>
                                            </b-btn> -->
                                        </b-btn-group>
                                    </template>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                    <b-row class="mb-3">
                        <b-col cols="12">
                            <b-pagination v-model="result_CurrentPage"
                                aria-controls="result-table"
                                :total-rows="result_history.length"
                                :per-page="result_PerPage"
                                :disabled="is_loading_result_history"
                                class="mr-2 mb-0"
                                align="center"
                            >
                            </b-pagination>
                        </b-col>
                    </b-row>
                </qesg-dash-table-card>
            </b-col>
        </b-row>
        
        <b-modal id="modal-report-viewer" :title="$t('결과보고서 보기')" size="xxl"
            hide-footer
            body-bg-variant="white"
            scrollable
            centered
            @hidden="onHiddenRerportViewer"
            >
            <b-tabs content-class="bg-white border-left border-right border-bottom"
                nav-class="h5 mb-0"
                >
                <b-tab :title="$t('결과보고서 보기')" title-link-class="gray-500 fw-500" active>
                    <div class="p-3">
                        <ReportViewerContainer
                            :view_target_report="view_target_report"
                            :view="true"
                            :report_lang="$i18n.locale"
                            />
                    </div>
                </b-tab>
                <b-tab :title="$t('답변보기')" title-link-class="gray-500 fw-500">
                    <b-row no-gutters>
                        <b-col cols="4" class="border-right">
                            <div class="border-bottom border-gray300 py-2 px-3">
                                <h5 class="gray-500 mb-0"> Questions </h5>    
                            </div>
                            <div class="bgray-100 overflow-auto pl-3 pr-2 py-2" style="height: 70vh;">
                                <audit-question-list></audit-question-list>
                            </div>
                        </b-col>
                        <b-col cols="8">
                            <div class="position-relative evaluation-panel-1 h-100">
                                <div class="d-flex border-bottom border-gray300 pb-2 pt-2 px-3">
                                    <h5 class="gray-500 mr-auto mb-0"> Answers </h5>
                                    
                                    <DropdownLanguage size="sm" class="mr-2" :disabled="client_report_global_disabled" />
                                    <template v-if="is_admin === 4">
                                        <AuditPrintButton
                                            btn_variant="subtop"
                                            size="sm"
                                            :d_none="is_printing === true ? 'd-none' : ''"
                                            @modal-opened="is_printing = true"
                                            @modal-closed="is_printing = false"
                                            >
                                            {{ $t('답변 전체 인쇄/다운로드')}}
                                            
                                            <fa icon="print" class="ml-2"></fa>
                                        </AuditPrintButton>
                                    </template>
                                </div>
                                <template v-if="subs_loaded">
                                    <div v-if="!subs.length" class="d-flex align-items-center justify-content-center bgray-200 rounded py-5" style="height: 70vh">
                                        {{ $t('이 문항에는 표시할 답변이 없습니다.') }}
                                    </div>
                                    <div v-else class="px-3 pt-2" style="overflow-y: auto; overflow-x: hidden; height: 70vh;">
                                        <sub-component v-for="(sub, sub_idx) in subs" :key="`sub-${sub_idx}-${sub.sub_code}`"
                                            :ref="sub.sub_code" 
                                            :sub_type="sub.sub_type"
                                            :item="sub"
                                            :is_disabled_by_parent="true"
                                            :audit_mode="false"
                                            />
                                    </div>
                                </template>
                                <template v-else-if="question_composition.question_code === ''">
                                    <div class="d-flex align-items-center justify-content-center bgray-200 rounded py-5" style="height: 70vh">
                                        Questions에서 질문명을 클릭하여 평가를 시작하세요
                                    </div>
                                </template>
                                <template v-else-if="subs_load_error">
                                    <div class="d-flex flex-column align-items-center justify-content-center text-center" style="height: 70vh">
                                        <h6 class="text-danger">{{ $t('답변을 불러오지 못했습니다.') }}</h6>
                                        <b-btn size="sm" variant="outline-secondary" @click="loadSubs(question_composition)">{{ $t('다시 시도') }}</b-btn>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="text-center" style="height: 70vh">
                                        <b-spinner class="my-5 gray-500"></b-spinner>
                                    </div>
                                </template>
                            </div>
                        </b-col>
                    </b-row>
                </b-tab>
            </b-tabs>
        </b-modal>
    </b-container>
</template>

<script>
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
import { BIconArrowRepeat, BIconFilter } from 'bootstrap-vue';
import AssessmentCommonMixin from '@shared_mixins/assessment.common.mixin.js';
import initializeDataProgress from '@shared_mixins/contractor-dashboard/initialize-data-progress';
import ReportViewerContainer from '@shared_components/admin/components/report/ReportViewerContainer.vue';
import AuditQuestionList from '@shared_components/admin/components/audit/AuditQuestionList.vue';
import AuditPrintButton from '@shared_components/admin/components/common/AuditPrintButton';
import DropdownLanguage from '@shared_components/utils/dropdown-language';
import QesgDashTableCard from '@shared_components/contractor/components/qesg-dash-table-card.vue';
import subComponent from '@core_components/admin/components/subs/SubComponent.vue';

export default {
    name: 'ContractorReport',
    props: {
        loadedRequiredData: {
            required: true,
            type: Boolean
        }
    },
    mixins: [
        initializeDataProgress,
        AssessmentCommonMixin
    ],
    components: {
        AuditPrintButton,
        BIconArrowRepeat,
        BIconFilter,
        ReportViewerContainer,
        AuditQuestionList,
        DropdownLanguage,
        QesgDashTableCard,
        subComponent
    },
    data() {
        return {
            is_loading_result_history: false,
            result_history: [],
            result_CurrentPage: 1,
            result_PerPage: 20,

            // download
            download_target_report: {
                company_id: null,
                type: null // doc, osis
            },

            // view
            is_viewing_report: false,
            result_history_loaded: false,
            ecovadis_load_error: false,
            subs_load_error: false,
            view_target_report: null,

            // search condition
            status_code_opts: [
                { text_ko: '-- 전체보기 --', text_en: '-- View All --', text_ca: '-- 查看全部 --', value: null },
                { text_ko: '미신청', text_en: 'Not Applied', text_ca: '未申请', value: 'not_requested' },
                { text_ko: '신청함', text_en: 'Applied', text_ca: '已申请', value: 'requested' },
                { text_ko: '답변중', text_en: 'In Progress', text_ca: '进行中', value: 'in_progress' },
                { text_ko: '보완중', text_en: 'Re-Progress', text_ca: '修订中', value: 're_progress' },
                { text_ko: '평가중', text_en: 'In Assessment', text_ca: '评估中', value: 'in_assessment' },
                { text_ko: '완료됨', text_en: 'Completed', text_ca: '已完成', value: 'completed' },
                { text_ko: '취소됨', text_en: 'Canceled', text_ca: '已取消', value: 'canceled' },
                { text_ko: '에코바디스', text_en: 'Eco-vadis', text_ca: 'Eco-vadis', value: 'eco_vadis' },
            ],
            reportSearchForm: {
                company_name: null,
                service_type: null,
                status_code: null,
                report_type: null,
                collapseForm: false
            },
            status_code_ko: {
                not_requested: '미신청',
                requested: '신청함',
                in_progress: '답변중',
                re_progress: '보완중',
                in_assessment: '평가중',
                completed: '완료됨',
                canceled: '취소됨',
                eco_vadis: '에코바디스',
            },
            status_code_en: {
                not_requested: 'Not Applied',
                requested: 'Applied',
                in_progress: 'In Progress',
                re_progress: 'Re-Progress',
                in_assessment: 'In Assessment',
                completed: 'Completed',
                canceled: 'Canceled',
                eco_vadis: 'Eco-vadis',
            },
            status_code_ca: {
                not_requested: '未申请',
                requested: '已申请',
                in_progress: '进行中',
                re_progress: '修订中',
                in_assessment: '评估中',
                completed: '已完成',
                canceled: '已取消',
                eco_vadis: 'Eco-vadis',
            },
            
            // Viewer
            reportPDFLoadProgress: 0,
            reportPDFLoaded: false,

            // 보고서 언어 - report_lang (report.hmc.mixin.js 에 있음) 변경시 언어 지원 결과보고서 미리보기용 데이터
            pdf_filename: null,
            reportMode: 'full',
            needReport: false,
            reportData: { info: null, benchmarks: null, parser: null, risk: null, scoring: null },

            // 기업 답변 관련 데이터
            answer_audit_mode: 'evaluation',
            is_printing: false,

            lang_pattern: /(KOR|CHI|ENG)/g,
            lang_pattern_pair: { KOR: 'ko', CHI: 'ca', ENG: 'en' },
            lang_pattern_reverse_pair: { ko: 'KOR', ca: 'CHI', en: 'ENG' },
        };
    },
    computed: {
        // 기업 답변 관련 데이터
        ...mapState(['question_composition', 'is_admin']),
        ...mapState('questions', ['subs', 'answer_company', 'subs_loaded']),
        ...mapGetters('contractor', ['GET_ECOVADIS_OBJ']),
        result_history_fields(){
            return [
                {
                    key: 'index',
                    label: this.$t('번호'),
                    thStyle: [
                        { width: '7%' },
                        { textAlign: 'center'}
                    ],
                    tdClass: ['text-center', 'align-middle'],
                    sortable: true
                },
                {
                    key: 'company_name',
                    label: this.$t('기업명'),
                    thClass: ['text-center', 'align-middle'],
                    sortable: true
                },
                {
                    key: 'service_type',
                    label: this.$t('평가 유형'),
                    thStyle: [
                        { width: '12.5%' },
                        { textAlign: 'center' }
                    ],
                    tdClass: ['text-center', 'align-middle'],
                    sortable: true
                },
                {
                    key: 'status_code',
                    label: this.$t('평가 상태'),
                    thStyle: [
                        { width: '12.5%' },
                        { textAlign: 'center' }
                    ],
                    tdClass: ['text-center', 'align-middle'],
                    sortable: true
                },
                {
                    key: 'report_doc',
                    label: this.$t('서면평가 결과보고서'),
                    thStyle: [
                        { width: '20%' },
                        { textAlign: 'center' }
                    ],
                    tdClass: ['text-center', 'align-middle'],
                    sortable: true
                },
                {
                    key: 'report_osis',
                    label: this.$t('실사평가 결과보고서'),
                    thStyle: [
                        { width: '20%' },
                        { textAlign: 'center' }
                    ],
                    tdClass: ['text-center', 'align-middle'],
                    sortable: true
                }
            ];
        },

        // 결과보고서 관련 데이터
        client_report_global_disabled () {
            return this.is_loading_result_history
                || this.is_viewing_report
                || this.download_target_report.company_id !== null
                || !this.loadedRequiredData;
        },
        status_code_lang () {
            return this.$i18n.locale === 'ko'
                ? this.status_code_ko
                : this.$i18n.locale === 'en'
                    ? this.status_code_en
                    : this.status_code_ca;
        },
        reportTablePerPageOpt () {
            if (this.$i18n.locale === 'ko') {
                return [
                    { text: '10개씩 보기', value: 10 },
                    { text: '20개씩 보기', value: 20 },
                    { text: '30개씩 보기', value: 30 },
                    { text: '40개씩 보기', value: 40 },
                    { text: '50개씩 보기', value: 50 },
                ];
            } else if (this.$i18n.locale === 'en') {
                return [
                    { text: 'View 10 per page', value: 10 },
                    { text: 'View 20 per page', value: 20 },
                    { text: 'View 30 per page', value: 30 },
                    { text: 'View 40 per page', value: 40 },
                    { text: 'View 50 per page', value: 50 }
                ];
            } else {
                return [
                    { text: '每页显示 10条', value: 10 },
                    { text: '每页显示 20条', value: 20 },
                    { text: '每页显示 30条', value: 30 },
                    { text: '每页显示 40条', value: 40 },
                    { text: '每页显示 50条', value: 50 }
                ];
            }
        },
    },
    watch: {
        loadedRequiredData: {
            async handler (_state, _old_state) {
                if (_state && !_old_state) {
                    // await this.addFontVFS();
                    await this.getProjectReport();
                }
            }
        },
        async '$route.query.projectid' (_updated_project_id) {
            // 초기화
            this.result_history = [];
            this.result_history_loaded = false;
            this.result_CurrentPage = 1;
            this.result_PerPage = 20;
            this.download_target_report = {
                company_id: null,
                type: null // doc, osis
            },
            this.view_target_report = null;
            if (!_updated_project_id) return;
            await this.getProjectReport(_updated_project_id);
        },
        '$i18n.locale': {
            immediate: true,
            handler(_i18n_lang) {
                this.report_lang = _i18n_lang;
            }
        },
        question_composition: {
            deep: true,
            async handler (_updated) {
                await this.loadSubs(_updated);
            }
        },
        '$route.query.report' () {
            this.syncReportViewer();
        },
        answer_company: {
            async handler (_answer_company) {
                this.initAttachmentsStorage();

                if (_answer_company.campaign_id && _answer_company.company_id) {
                    await this.getAttatchments({ campaign_id: _answer_company.campaign_id, company_id: _answer_company.company_id });
                }
            }
        }
    },
    async created() {
        this.$emit('emit-loaded-status', false);
        this.report_lang = this.$i18n.locale;
    },
    async mounted() {
        if (this.loadedRequiredData) {
            await this.getProjectReport();
            this.$emit('emit-loaded-status', true);
        }
    },
    beforeDestroy() {},
    methods: {
        ...mapMutations(['set_admin_mode', 'set_view_mode', 'update_question_composition']),
        ...mapMutations('questions', ['update_answer_company', 'update_subs', 'update_subs_loaded']),
        ...mapActions('reviews',['initiateReviews']),
        ...mapActions(['readTemplateTree', 'makeTemplateTreeByCompanyId']),
        ...mapMutations('attachments', ['initAttachmentsStorage']),
        ...mapActions('attachments', ['getAttatchments']),
        ...mapMutations('contractor', ['SET_ECOVADIS_OBJ']),
        async loadSubs (_composition) {
            this.$store.commit('update_is_question_subs_loaded', false);
            this.subs_load_error = false;

            if (_composition.question_contents) {
                await this.$store.dispatch('questions/readSubs', {
                    campaign_id: this.answer_company.campaign_id,
                    company_id: this.answer_company.company_id,
                    company_name: this.answer_company.company_name,
                    code: _composition.question_code,
                    contents: _composition.question_contents
                });
                // readSubs 는 실패해도 throw 하지 않고 loaded 를 true 로 올리지 못한 채 끝난다
                this.subs_load_error = !this.subs_loaded;
            } else if (_composition.question_code) {
                this.update_subs([]);
                this.update_subs_loaded(true);
            }

            this.$store.commit('update_is_question_subs_loaded', true);
        },
        async initEcovadisObj(){
            const { data } =  await this.$projectsAxios.get(`/${this.$route.query.projectid}/overall`);
            if(data.participant?.length > 0){
                const ecovadis_obj = {};
                data.participant.forEach(participant => {
                    if(participant.status_code === 'eco_vadis'){
                        ecovadis_obj[participant.company_id] = true;
                    }
                });
                this.SET_ECOVADIS_OBJ(ecovadis_obj);
            }
        },
        async getProjectReport (_projectid = this.$route.query.projectid) {
            try {
                this.is_loading_result_history = true;
                this.ecovadis_load_error = false;
                if(Object.keys(this.GET_ECOVADIS_OBJ).length === 0){
                    try {
                        await this.initEcovadisObj();
                    } catch (error) {
                        console.error('[ContractorReport] initEcovadisObj error:', error);
                        this.ecovadis_load_error = true;
                    }
                }
                if ((_projectid === 'latest' && this.$store.getters['contractor/GET_ProjectList'].length) || _projectid !== 'latest') {
                    const _project_code = _projectid !== 'latest' ? _projectid : this.$store.getters['contractor/GET_ProjectList'][0].project_code;
                    const _res_project_report_history = await this.$axios('/report/history', {
                        params: { project_code: _project_code, with_alt: true, confirmed: 1 }
                    });

                    let _project_report = this.sortingCompanies(_res_project_report_history.data.result);
                    if (!_project_report.length) {
                        _project_report = _project_report.reduce((_project_scoring, _company) => {
                            if (_company.scores) _company.scores = null;
                            _project_scoring.push(_company);
                            return _project_scoring;
                        }, []);
                    } else {

                        const _company_id_list = _project_report.map(({ company_id }) => company_id);
                        const _company_list = new Set(_company_id_list);

                        _project_report = [..._company_list].reduce((_project_scoring, _company_id) => {
                            const _company_confirmed_reports = _project_report.filter(_report => _report.company_id === _company_id);
                            const {
                                id, project_code, campaign_id, campaign_name, company_id, company_name, requested_id, service_type, status_code, template_code, priority
                            } = _company_confirmed_reports[0].priority || _company_confirmed_reports[0];
                            
                            if(this.GET_ECOVADIS_OBJ[company_id]){ // ecovadis 제외
                                return _project_scoring;
                            }
                            
                            _project_scoring[_company_id] = { id, project_code, campaign_id, campaign_name, company_id, company_name, requested_id, service_type, status_code, template_code, priority };

                            const _company_report_doc = _company_confirmed_reports.find(({ mode, priority }) => mode === 'DOC' || (priority && priority.mode === 'DOC'));
                            if (!_company_report_doc) {
                                _project_scoring[_company_id]['report_doc'] = null;   
                            } else {

                                let { id, campaign_id, report_ext, report_key, report_name, report_path, time_stamp } = _company_report_doc.priority || _company_report_doc;
                                const _doc_lang_match = report_name?.match(this.lang_pattern);
                                _project_scoring[_company_id]['report_doc'] = {
                                    report_history_id: id,
                                    project_code, campaign_id, campaign_name, company_id, company_name, requested_id, service_type, status_code, template_code,
                                    report_ext, report_key, report_name, report_path, time_stamp,
                                    report_lang: _doc_lang_match?.length ? this.lang_pattern_pair[_doc_lang_match[0]] : 'ko',
                                    has_multi_lang: !!_doc_lang_match?.length
                                };
                            }

                            if (service_type === '심화') {
                                const _company_report_osis = _company_confirmed_reports.find(({ mode, priority }) => mode === 'OSIS' || (priority && priority.mode === 'OSIS'));
                                if (_company_report_osis) {
                                    const { id, campaign_id, report_ext, report_key, report_name, report_path, time_stamp } = _company_report_osis.priority || _company_report_osis;
                                    const _osis_lang_match = report_name?.match(this.lang_pattern);
                                    _project_scoring[_company_id]['report_osis'] = {
                                        report_history_id: id,
                                        project_code, campaign_id, campaign_name, company_id, company_name, requested_id, service_type, status_code, template_code,
                                        report_ext, report_key, report_name, report_path, time_stamp,
                                        report_lang: _osis_lang_match?.length ? this.lang_pattern_pair[_osis_lang_match[0]] : 'ko',
                                        has_multi_lang: !!_osis_lang_match?.length
                                    };
                                }
                            }


                            return _project_scoring;
                        }, {});
                    }

                    this.result_history = Object.values(_project_report);
                }
            } catch (error) {
                console.error('[ContractorReport] getProjectReport error:', error);
                if (this.$i18n.locale === 'ko') {
                    alert('죄송합니다. 결과보고서 처리 중 장애가 발생했습니다. QESG info 메일로 문의 부탁드립니다.');
                } else if (this.$i18n.locale === 'en') {
                    alert('Sorry, there was an error while processing the results report. Please contact QESG info email for assistance.');
                } else {
                    alert('抱歉，处理报告时发生错误。请通过电子邮件联系 QESG 信息寻求帮助。');
                }
            } finally {
                this.is_loading_result_history = false;
                this.result_history_loaded = true;
                this.$emit('emit-loaded-status', true);
                this.syncReportViewer();
            }
        },
        // URL 의 report/rtype 으로 뷰어를 연다. 값은 신뢰하지 않고 조회된 목록에서만 찾는다
        syncReportViewer () {
            const { report, rtype } = this.$route.query;
            if (!report) {
                if (this.view_target_report?.mode === 'view') {
                    this.$bvModal.hide('modal-report-viewer');
                }
                return;
            }
            if (!this.result_history_loaded || this.is_viewing_report) return;
            if (this.view_target_report && String(this.view_target_report.company_id) === String(report)) return;

            const _report_type = rtype === 'osis' ? 'osis' : 'doc';
            const _target = this.result_history.find(({ company_id }) => String(company_id) === String(report));
            if (_target && _target[`report_${_report_type}`]) {
                this.viewReport(_target, _report_type);
            } else {
                this.$router.replace({ name: this.$route.name, query: { projectid: this.$route.query.projectid }}).catch(() => {});
            }
        },
        async viewReport (_report, _report_type, only_report_url = false) {
            try {
                const { project_code, campaign_id, campaign_name, company_id, company_name, template_code } = _report;

                const _legacy_query = {projectid: project_code,pc: project_code, cmp: campaign_id, cpn: company_id, cpnm: company_name };
                if (only_report_url) {
                    this.$router.replace({ name: this.$route.name, query: _legacy_query });
                }
                
                if (!only_report_url) {
                    this.is_viewing_report = true;
                    // 뒤로가기·새로고침·링크 공유로 복원되도록 대상은 report/rtype 으로 기록 (pc/cmp/cpn/cpnm 은 답변보기 탭이 읽는다)
                    this.$router.push({
                        name: this.$route.name,
                        query: { ..._legacy_query, report: company_id, rtype: _report_type }
                    }).catch(() => {});

                    this.set_admin_mode('project');
                    this.update_answer_company(_report);
                    this.set_view_mode('user');
                    await this.readTemplateTree({
                        template_code, company_id,
                        is_previous: false
                    }),
                    await this.makeTemplateTreeByCompanyId({ campaign_id, company_id });
                }

                let _selected_report = null;
                if (_report[`report_${_report_type}`]) {
                    _selected_report = { ..._report[`report_${_report_type}`] };
                } else if (_report['report']) {
                    _selected_report = { ..._report.report };
                } else {
                    throw new Error('Not_Found_Report_Data');
                }

                this.view_target_report = {
                    project_code, campaign_name, company_id, company_name,
                    report_type: _report_type,
                    report: _selected_report,
                    mode: only_report_url ? 'download' : 'view'
                };

                this.$nextTick(() => {
                    this.$bvModal.show('modal-report-viewer');
                });
            } catch (error) {
                if (!only_report_url) {
                    this.$router.replace({ name: this.$route.name, query: { projectid: this.$route.query.projectid }}).catch(() => {});
                }
                alert(this.$t('죄송합니다. 결과보고서를 불러오는 도중 장애가 발생했습니다. QESG info@qesg.co.kr 로 문의해주시기 바랍니다.'));
            } finally {
                if (!only_report_url) {
                    this.is_viewing_report = false;
                }
            }
        },
        // async downloadReport (_report, _company_id, _report_type) {
        // },
        onHiddenRerportViewer () {
            this.pdf_filename = null;
            this.needReport = false;
            
            if (this.view_target_report && this.view_target_report.mode === 'view') {
                URL.revokeObjectURL(this.view_target_report.report.report_url);
            }

            this.reportData = { info: null, benchmarks: null, parser: null, risk: null, scoring: null };

            this.reportPDFLoadProgress = 0;
            this.reportPDFLoaded = false;

            let _revoking_ObjectURL = null;
            if (this.view_target_report && this.view_target_report?.report?.report_url && this.view_target_report?.report?.report_url.includes('blob')) {
                _revoking_ObjectURL = this.view_target_report.report.report_url;
            }

            this.view_target_report = null;

            if (_revoking_ObjectURL) URL.revokeObjectURL(_revoking_ObjectURL);
            this.report_lang = this.$i18n.locale;
            
            this.update_answer_company({});
            this.set_admin_mode('camp');
            this.set_view_mode('provider');
            this.update_subs_loaded(false);
            this.update_question_composition({});
            this.$router.replace({ name: this.$route.name, query: { projectid: this.$route.query.projectid }}).catch(() => {});
        },
        onReportLoaded () {
            this.reportPDFLoaded = true;
        },
        onProgressReportLoad (onProgress) {
            this.reportPDFLoadProgress = (onProgress.loaded / onProgress.total) * 100;
        },
        
        onFilterReportTable (filteredItems) {
            this.result_CurrentPage = 1;
            this.releaseTableRows = filteredItems.length;
        },
        filterReportTable (item) {
            let _is_item_filtered = true;
            if (this.reportSearchForm.company_name && _is_item_filtered) {
                _is_item_filtered = item.company_name.toLowerCase().includes(this.reportSearchForm.company_name.toLowerCase());
            }

            if (this.reportSearchForm.service_type && _is_item_filtered) {
                _is_item_filtered = item.service_type === this.reportSearchForm.service_type;
            }

            if (this.reportSearchForm.status_code && _is_item_filtered) {
                _is_item_filtered = item.status_code === this.reportSearchForm.status_code;
            }

            if (this.reportSearchForm.report_type && _is_item_filtered) {
                _is_item_filtered = !!item[this.reportSearchForm.report_type];
            }

            return _is_item_filtered;
        }
    },
};
</script>
